import React from 'react';

const Quote = () => (
  <div id="quote">
    <ul>
      <li>
        &quot;Mathematics is the music of reason.&quot;
        <span>-James Joseph Sylvester</span>
      </li>
      <li>
        &quot;‘Obvious’ is the most dangerous word in mathematics.&quot;
        <span>-Eric Temple Bell</span>
      </li>
      <li>
        &quot;Mathematics allows for no hypocrisy and no vagueness.&quot;
        <span>-Stendhal</span>
      </li>
      <li>
        &quot;It is impossible to be a mathematician without being a poet in soul.&quot;
        <span>-Sofia Kovalevskaya</span>
      </li>
      <li>
        &quot;Go down deep enough into anything and you will find mathematics.&quot;
        <span>-Dean Schlicter</span>
      </li>
    </ul>
  </div>
);

export default Quote;
